import React from 'react';
export default function HomePage(){
    return (
        <div>
            <h1>Not Found PagePage</h1>
        </div>
    );
}